import { Option } from '../option';
import { ArrayOps, getValue } from '../lift';
/**
 * Maps this Array to an Array of Array | Option | ArrayOps using a mapper function then flattens it.
 */
export function flatMap(fun) {
    var arr = this.value(), result = [];
    for (var i = 0; i < arr.length; i++) {
        var item = fun(arr[i], i);
        if (Option.isOption(item))
            item.isDefined() && result.push(item.get());
        else
            result.push.apply(result, getValue(item));
    }
    return new ArrayOps(result);
}
ArrayOps.prototype.flatMap = flatMap;
